<template>
    <div>
        <div style="height: 192px;"><img style="width: 100%;height: 100%;" src="@/assets/images/Rectangle.png" alt="">
        </div>
        <div class="wrap">
            <div class="title">{{ list.title }}</div>
            <el-divider></el-divider>
            <div class="tiele_2" style="text-align: left;margin: 30px auto;width: 100%;">
                <div class="bor"></div>报名须知
            </div>
           
            <div class="content" v-html="list.examNote">
            </div>
        </div>

        <div style="position: fixed;width: 100%;bottom: 20px;">
            <router-link to="/login"> <el-button type="primary" class="btn">立即报名</el-button></router-link>
        </div>


    </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
export default {
    data() {
        return {
            id: '',
            list: {
            },
        }
    },
    mounted() {

        console.log(this.$route.query.id);
        this.id = this.$route.query.id;
        // axios.get(`${Vue.prototype.baseUrl}/exam/getExamnotesById/${this.id}`).then(res => {

        // })

        axios({
            method: 'GET',
            url: `${Vue.prototype.baseUrl}/exam/getExamnotesById/${this.id}`,
            headers: {
                // 'Authorization': getToken(),
                'Content-Type': 'application/json',
            }
        }).then((res) => {

            var data = res.data.data
            this.list = data || {}
            console.log(data);
        })
    },
    methods: {},
}
</script>

<style lang="scss" scoped>
.btn {
    border-radius: 16px;
    width: 80%;
}

.wrap {
    background-color: #fff;
    padding: 16px;
    padding-bottom: 60px;
    padding-top: 28px;
    box-sizing: border-box;
    height: calc(100vh - 192px);
    overflow-y: scroll;
}

.title {
    // margin-top: 28px;
    font-size: 15px;
    font-family: Source Han Sans CN, Source Han Sans CN-500;
    font-weight: 500;
    text-align: center;
    color: #333333;
    line-height: 20px;
    letter-spacing: 0px;
}

.el-divider {
    width: 100%;
    margin: 24px auto;
    margin-bottom: 0;
}

.content {
    height: calc(100% - 130px);
    overflow: scroll;
    background-color: #fff;
    text-align: left;
}

.tiele_2 {
    font-size: 13px;
    font-family: Source Han Sans CN, Source Han Sans CN-500;
    font-weight: 500;
    text-align: LEFT;
    color: #333333;
    line-height: 20px;
    letter-spacing: 0px;
}

.bor {
    display: inline-block;
    margin-right: 5px;
    width: 4px;
    height: 12px;
    background: #4077f6;
    border-radius: 4px;
}
</style>